import { createAsyncThunk } from "@reduxjs/toolkit";
import AxiosDefaultSetting from "../AxiosDefault";
import toast from "react-hot-toast";

//signin user
export const signInUser = createAsyncThunk(
  "auth/signin",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosDefaultSetting({
        method: "POST",
        url: "/auth/login", //endpoint
        data: data,
      });

      return response.data;
    } catch (error) {
      console.log("error", error);
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);
//signin user
export const signUpUser = createAsyncThunk(
  "auth/signup",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosDefaultSetting({
        method: "POST",
        url: "/auth/signup", //endpoint
        data: data,
      });
      return response.data;
    } catch (error) {
      console.log("error", error);
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);
//register company
export const comapnyRegisterService = createAsyncThunk(
  "comapny/register",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosDefaultSetting({
        method: "POST",
        url: "/auth/company-register", //endpoint
        contentType: "multipart/form-data",
        data: data,
      });
      return response.data;
    } catch (error) {
      console.log(error, "err");
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

export const logoutUser = createAsyncThunk("auth/logout", async () => {
  try {
    // Perform any necessary cleanup here, e.g., invalidating tokens on the server

    // Clear the token from local storage
    const rememberedUser = localStorage.getItem("rememberedUser");

    // Clear everything from localStorage
    localStorage.clear();

    // If "rememberedUser" exists, put it back into localStorage
    if (rememberedUser) {
      localStorage.setItem("rememberedUser", rememberedUser);
    }
    // Redirect the user or perform other actions after logout
    window.location.href = `/`;

    // Show a success message
    toast.success("Logged out successfully");
  } catch (error) {
    toast.error("Error logging out");
  }
});

//reset password
export const resetPasswordService = createAsyncThunk(
  "/api/reset-password",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosDefaultSetting({
        method: "POST",
        url: "/auth/reset-password", //endpoint
        data: data,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);
//forgot password
export const forgotpasswordService = createAsyncThunk(
  "/api/forgot-password",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosDefaultSetting({
        method: "POST",
        url: "/auth/forgot-password", //endpoint
        data: data,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);
//Resend otp
export const ResendOtpService = createAsyncThunk(
  "/api/resend-password",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosDefaultSetting({
        method: "POST",
        url: "/auth/resend-verification-email", //endpoint
        data: data,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

//email varifications
export const VerifyEmailApi = createAsyncThunk(
  "auth/verieyEmail",
  async (token, { rejectWithValue }) => {
    try {
      const response = await AxiosDefaultSetting({
        method: "GET",
        url: `/auth/verify-email/${token}`, //endpoint
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

//accept terms
export const acceptTerms = createAsyncThunk(
  "auth/acceptTerms",
  async (_, { rejectWithValue }) => {
    try {
      const response = await AxiosDefaultSetting({
        method: "PUT",
        url: "/accept-terms",
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);
